import { ApiResponse } from '../api'
import { axios } from '@src/lib/axios'

export type Category = 'pio'|'sfx'|'station'|'shift'|'car-part'|'employee'|'car-info'|'qa'|'pio-arg'

export interface UploadFileReqDto {
  category: Category;
  file: File;
}

/** 上傳檔案 */
export async function uploadFile(reqDto: UploadFileReqDto) {
  const { category, file } = reqDto

  const formData = new FormData()

  formData.append('file', file)
  await axios.post<ApiResponse<void>>(
    `/api/web/import/${category}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
}
  
export interface DeleteCarInfoByShippingNoReqDto {
  shippingNo: string;
}

/** 依船次編號刪除整船資料 */
export async function deleteCarInfoByShippingNo(reqDto: DeleteCarInfoByShippingNoReqDto) {
  const { shippingNo } = reqDto
  await axios.delete<ApiResponse<void>>(`/api/web/import/car-info/${shippingNo}`)
}